/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GiornoDellaSettimanaEnum } from './giorno-della-settimana-enum';


export interface ServizioMensaChiusureSettimanaliForm { 
    giorni_della_settimana_di_chiusura?: Array<GiornoDellaSettimanaEnum>;
}

